<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
    seo: { type: Object, required: true },
});
</script>

<template>
    <Head>
        <title>{{ seo.title }}</title>
        <meta head-key="description" name="description" :content="seo.description" />
        <meta head-key="robots" name="robots" :content="seo.robots" />
        <meta head-key="viewport" name="viewport" content="width=device-width, initial-scale=1" />
        <link head-key="canonical" rel="canonical" :href="seo.canonical" />
        <meta head-key="og:title" property="og:title" :content="seo.title" />
        <meta head-key="og:description" property="og:description" :content="seo.description" />
        <meta head-key="og:url" property="og:url" :content="seo.canonical" />
        <meta head-key="og:type" property="og:type" :content="seo.type" />
        <meta v-if="seo.image" head-key="og:image" property="og:image" :content="seo.image" />
    </Head>
</template>
